export const API_BASE_URL = import.meta.env.VITE_MURF_SERVICE as string;
